import { render, staticRenderFns } from "./editStoretag.vue?vue&type=template&id=7c3c0f63&scoped=true"
import script from "./editStoretag.vue?vue&type=script&lang=js"
export * from "./editStoretag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c0f63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c3c0f63')) {
      api.createRecord('7c3c0f63', component.options)
    } else {
      api.reload('7c3c0f63', component.options)
    }
    module.hot.accept("./editStoretag.vue?vue&type=template&id=7c3c0f63&scoped=true", function () {
      api.rerender('7c3c0f63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsLabel/editStoretag.vue"
export default component.exports